import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.23 9.23 0 0 0-7.161 3.395l1.53 4.592a.75.75 0 0 0 .436.46l.557-2.04A2.25 2.25 0 0 1 9.532 7.5h2.278a.75.75 0 0 0 .57-.262l2.19-2.555a.75.75 0 0 0 .18-.488v-1.03A9.3 9.3 0 0 0 12 2.75M2.75 12a9.2 9.2 0 0 1 1.039-4.263l1.158 3.474A2.25 2.25 0 0 0 7.08 12.75h1.294c.07 0 .125.056.125.125 0 .898.728 1.625 1.625 1.625h.35l-.569 1.074c-.497.94-.269 2.1.548 2.781l1.229 1.023a.75.75 0 0 1 .216.855l-.401 1.004A9.25 9.25 0 0 1 2.75 12m10.385 9.181a9.25 9.25 0 0 0 6.683-4.235l-4.662-3.107a.75.75 0 0 0-.354-.124l-1.627-.135a.75.75 0 0 0-.726.396l-1.217 2.3a.75.75 0 0 0 .183.927l1.228 1.023a2.25 2.25 0 0 1 .649 2.564zm7.384-5.57c.47-1.11.731-2.33.731-3.611a9.25 9.25 0 0 0-5-8.218v.413a2.25 2.25 0 0 1-.542 1.464l-2.19 2.555A2.25 2.25 0 0 1 11.81 9H9.532a.75.75 0 0 0-.723.553l-.463 1.697h.03c.897 0 1.624.727 1.624 1.625 0 .069.056.125.125.125h1.17a2.25 2.25 0 0 1 2.004-.915l1.628.135c.379.032.744.16 1.06.37z"
      clipRule="evenodd"
    />
  </>
);

const Globe = Icon('globe', svgContents);

export default Globe;
